import { Dispatch, FC, SetStateAction } from 'react';
import useGroupDialog from './GroupDialogForm.hook';
import { loaderWrapperStyle } from './GroupDialogForm.style';
import DialogForm from 'components/DialogForm';
import Box from 'yoda-ui/components/Box/Box';
import CircularProgress from 'yoda-ui/components/CircularProgress';
import MultiSelectYoda from 'yoda-ui/components/Form/SelectYoda/MultiSelectYoda';
import { YodaFormProvider } from 'yoda-ui/yodaForm';

export type GroupDialogFormTypes = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  submitAction: Function;
};

const GroupDialogForm: FC<GroupDialogFormTypes> = ({ open, setOpen, submitAction }) => {
  const { groupDialogFormConfig, providerFields, loading } = useGroupDialog(open, setOpen, submitAction);
  return (
    <DialogForm { ...groupDialogFormConfig.dialog }>
      <YodaFormProvider { ...providerFields }>
        <Box>
          <MultiSelectYoda { ...groupDialogFormConfig.tacticsInGroup } />
        </Box>
      </YodaFormProvider>
      {
        loading ? (
          <Box sx={ loaderWrapperStyle }>
            <CircularProgress/>
          </Box>
        ) : null
      }
    </DialogForm>
  );
};

export default GroupDialogForm;
